import { TransportsFeature } from '../features/transports/transports.feature';
import { StandardLayerRenderer } from './standard-layer.renderer';

export class TransportsRenderer extends StandardLayerRenderer {
  protected Feature = TransportsFeature;
}
